function Frase() {
  return (
    <div className="bg-verde5 p-8 text-center relative z-0">
      <div className="flex flex-col justify-center items-center mt-2 gap-4">
        {/* Imagen 1 */}
        <div className="w-full max-w-sm h-[300px] bg-verde5 p-4 rounded-lg shadow-verde1 shadow-lg border-2 border-verde1">
          <img 
            src={require('../../Imagenes/IMG-20250915-WA0017.jpg')} 
            alt="Foto 1" 
            className="rounded-lg w-full h-full object-cover "
           // style={{ filter: 'sepia(0.8) brightness(1) contrast(1.1)' }}

          />
        </div>

        {/* Imagen 2 */}
        <div className="w-full max-w-sm h-[300px] bg-verde5 p-4 rounded-lg shadow-verde1 shadow-lg border-2 border-verde1">
          <img 
            src={require('../../Imagenes/IMG-20250915-WA0020.jpg')} 
            alt="Foto 2" 
            className="rounded-lg w-full h-full object-cover "
            //style={{ filter: 'sepia(0.8)' }}
          />
        </div>
         <div className="w-full max-w-sm h-[300px] bg-verde5 p-4 rounded-lg shadow-verde1 shadow-lg border-2 border-verde1">
          <img 
            src={require('../../Imagenes/IMG-20250915-WA0021.jpg')} 
            alt="Foto 2" 
            className="rounded-lg w-full h-full object-cover "
            //style={{ filter: 'sepia(0.8)' }}
          />
        </div>
      </div>
    </div>
  );
}

export default Frase;




